import { InputStep, Label, ReadonlyBlock } from '@/forms-legacy'

type StepInputProps = {
  label: string
  info: string
  value: number
  onChange: (value: number) => void
  testId?: string
  trackId?: string
}

export function StepInput(props: StepInputProps) {
  const { label, info, value, onChange, testId, trackId } = props
  return (
    <ReadonlyBlock half data-testid={testId} data-trackid={trackId}>
      <Label>{label}</Label>
      <InputStep value={value} onChange={onChange} step={1} canBeNaN={false} unit={info} min={1} />
    </ReadonlyBlock>
  )
}
